import { Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { getValue, setValue } from '@truqc/content-path';
import Loader from '../common/loader';
import TriStateChecklist from '../common/controls/triStateChecklist';
export default class DocumentAssociations extends Component {
  constructor(props) {
    super(props);
    this.setIsSelectingAssociationsFalse = this.setIsSelectingAssociations.bind(this, false);
    this.handleAssociationSelectionJobs = this.handleAssociationSelection.bind(this, 'jobs');
    this.handleAssociationSelectionDocumentTags = this.handleAssociationSelection.bind(this, 'cloudDocument/documentTags');
  }
  componentWillUnmount() {
    const {
      documentActions
    } = this.props;
    documentActions.selectIndexClear();
  }
  setIsSelectingAssociations(selecting) {
    const {
      documentActions,
      document
    } = this.props;
    // filters staid the same but list may not be accurate to filters, refresh
    documentActions.serverIndex(document.indexQuery);
    documentActions.setIsSelectingAssociations(selecting);
  }
  handleAssociationSelection(field, updatedEntity) {
    const {
      documentActions,
      document
    } = this.props;
    const selectionsToUpdate = this.handleSelectionChange(field, updatedEntity, document.selected);
    if (selectionsToUpdate.length) {
      documentActions.serverSaveAll(selectionsToUpdate);
    }
  }

  // This method looks at the selected documents and the new tristate and
  // returns a list of which documents need to be updated based upon selection
  handleSelectionChange(field, selectedAssociationItem, selectedIDs) {
    let changedItems = [];
    switch (selectedAssociationItem.status) {
      case TriStateChecklist.STATUS_ALL:
        // remove relation from all
        changedItems = this.removeSelectionFromAll(field, selectedAssociationItem, selectedIDs);
        break;
      case TriStateChecklist.STATUS_SOME:
      case TriStateChecklist.STATUS_NONE:
        // both some and none add relation to all
        changedItems = this.addSelectionToAll(field, selectedAssociationItem, selectedIDs);
        break;
      default:
      // do nothing
    }
    return changedItems;
  }
  addSelectionToAll(field, selectedItem, selectedIds) {
    const {
      document
    } = this.props;
    const result = [];
    selectedIds.map(id => {
      const obj = _.find(document.selections, {
        id
      });
      if (obj) {
        let value = getValue(field, obj);
        if (!value) {
          value = [];
          setValue(field, obj, []);
        }
        const fieldVals = value;

        // if we don't already find this id among the objects in this field's
        // array of values, then add it.
        if (fieldVals.some(o => o.id === selectedItem.id) === false) {
          // we did not already have this, so append it to the field list, and
          // return true from this filter.
          fieldVals.push(selectedItem);
          setValue(field, obj, fieldVals);
          result.push(obj);
        }
      }
      return null;
    });
    return result;
  }
  removeSelectionFromAll(field, selectedItem, selectedIds) {
    const {
      document
    } = this.props;
    const result = [];
    selectedIds.map(id => {
      const obj = _.find(document.selections, {
        id
      });
      const fieldVals = getValue(field, obj);

      // if we don't already find this id among the objects in this field's
      // array of values, then add it.
      const index = _.findIndex(fieldVals, o => o.id === selectedItem.id);
      if (index !== -1) {
        // we did not already have this, so append it to the field list, and
        // return true from this filter.
        fieldVals.splice(index, 1);
        setValue(field, obj, fieldVals);
        result.push(obj);
      }
      return null;
    });
    return result;
  }
  filterForSelectedDocs(fieldName, textName = 'name') {
    const {
      document
    } = this.props;
    const filteredSelection = [];
    if (document.selected) {
      const totalSelectedDocs = document.selected.length;
      _.map(document.selected, nextDocID => {
        const doc = _.find(document.selections, {
          id: nextDocID
        });
        if (doc) {
          const vals = getValue(fieldName, doc);
          _.map(vals, val => {
            const tmp = _.find(filteredSelection, j => j.id === val.id);
            if (tmp) {
              // already in the list of filtered values
              tmp.numDocs += 1;
            } else {
              const clone = _.clone(val);
              clone.numDocs = 1;
              if (textName !== 'name') {
                clone.name = val[textName];
              }
              filteredSelection.push(clone);
            }
          });
        }
      });
      // See if all the docs are associated with the same thing
      filteredSelection.map(field => {
        const f = field;
        f.all = field.numDocs === totalSelectedDocs;
        return field;
      });
    }
    return filteredSelection;
  }
  render() {
    const {
      document,
      jobOptions,
      tagOptions
    } = this.props;
    const filteredJobs = this.filterForSelectedDocs('jobs') || [];
    const filteredTags = this.filterForSelectedDocs('cloudDocument/documentTags') || [];
    const centerStyle = {
      textAlign: 'center'
    };
    const centerLowStyle = {
      textAlign: 'center',
      marginTop: '100px'
    };
    return /*#__PURE__*/React.createElement(Modal, {
      isOpen: true,
      toggle: this.hideModal
    }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", {
      className: "float-md-right",
      style: {
        marginTop: '20px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "t-da-done-header",
      onClick: this.setIsSelectingAssociationsFalse
    }, "Done")), /*#__PURE__*/React.createElement("h2", null, "Select Associations"), document.selectLoading ? /*#__PURE__*/React.createElement(Loader, {
      style: centerLowStyle
    }) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement("div", {
      style: centerStyle
    }, /*#__PURE__*/React.createElement("h5", null, "Jobs")), /*#__PURE__*/React.createElement("hr", null), jobOptions.length > 0 ? /*#__PURE__*/React.createElement(TriStateChecklist, {
      className: "t-da-job-assocations",
      disabled: document.loading,
      values: filteredJobs,
      options: jobOptions,
      optionsNameKeyAlt: "jobNumber",
      onSelect: this.handleAssociationSelectionJobs
    }) : /*#__PURE__*/React.createElement("div", null, "No jobs for these documents.")), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement("div", {
      style: centerStyle
    }, /*#__PURE__*/React.createElement("h5", null, "Tags")), /*#__PURE__*/React.createElement("hr", null), tagOptions.length > 0 ? /*#__PURE__*/React.createElement(TriStateChecklist, {
      className: "t-da-tag-assocations",
      disabled: document.loading,
      values: filteredTags,
      options: tagOptions,
      onSelect: this.handleAssociationSelectionDocumentTags
    }) : /*#__PURE__*/React.createElement("div", null, "No tags for these documents.")))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      className: "t-da-done-footer",
      onClick: this.setIsSelectingAssociationsFalse
    }, "Done")));
  }
}
DocumentAssociations.defaultProps = {
  jobOptions: [],
  tagOptions: [],
  document: {}
};
DocumentAssociations.propTypes = {
  document: PropTypes.shape({
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool
    }),
    loading: PropTypes.bool,
    selectLoading: PropTypes.bool,
    selected: PropTypes.arrayOf(PropTypes.string),
    selections: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  documentActions: PropTypes.shape({
    serverSaveAll: PropTypes.func,
    selectIndexClear: PropTypes.func,
    serverIndex: PropTypes.func,
    setIsSelectingAssociations: PropTypes.func
  }).isRequired,
  jobOptions: PropTypes.arrayOf(PropTypes.shape({})),
  tagOptions: PropTypes.arrayOf(PropTypes.shape({}))
};